import { useEffect, useState } from "react";
import axios from "axios";
import { useFormData } from '../ContextData/ContextData';
import './Num.scss';
import InnerNav from "../../../../components/InnerNav/InnerNav";
import Footer from "../../../../components/Footer/Footer";

// Extended details with random texts
const numberDetails = {
  lucky: { 
    key: "luckyNumber", 
    title: "Your Lucky Number is",
    texts: [
      "Your lucky number radiates positivity and attracts prosperity into your life. It acts like a guiding light, opening doors to opportunities you may not have noticed before, and ensuring that even small efforts bring great rewards.",
      "This number carries vibrations of good fortune and success. When it appears in your path, you’ll notice a smoother flow of events and situations aligning in your favor, helping you reach your goals faster.",
      "Your lucky number enhances your self-confidence and inner strength. It not only brings favorable circumstances but also empowers you to take bold steps toward growth and personal achievement.",
      "The energy of this number attracts balance, harmony, and fulfillment. You may notice sudden positive changes, new beginnings, and uplifting experiences whenever this number is present around you.",
      "Your lucky number symbolizes abundance and happiness. It reminds you that the universe is on your side, encouraging you to stay optimistic and to believe in the good things heading your way."
    ]
  },
  unlucky: { 
    key: "unluckyNumber", 
    title: "Your Unlucky Number is",
    texts: [
      "This number is often associated with challenges and roadblocks. It may indicate times when progress feels slow, but it teaches you patience and resilience to overcome difficulties.",
      "The vibrations of this number may attract delays, misunderstandings, or unexpected complications. It serves as a reminder to stay cautious and avoid making hasty choices.",
      "Although seen as unlucky, this number holds hidden lessons. It often pushes you to reflect, adapt, and grow stronger by facing situations you would otherwise avoid.",
      "When this number influences your path, you may feel drained or restricted. It is a signal from the universe to be mindful of your energy and protect yourself from negativity.",
      "This number symbolizes temporary setbacks. While it may bring short-term struggles, it also prepares you for long-term success by building wisdom and inner strength."
    ]
  },
  destiny: { 
    key: "destinyNumber", 
    title: "Your Destiny Number is",
    texts: [
      "Your destiny number reveals your life’s true mission and higher calling. It shows the direction the universe wants you to take, guiding you toward opportunities that align with your soul’s purpose.",
      "This number acts as a compass for your life. It indicates the values, strengths, and talents you are meant to embrace in order to achieve fulfillment and leave a meaningful impact on the world.",
      "Your destiny number highlights your ultimate potential. It represents the challenges you are destined to conquer and the victories you are meant to celebrate as part of your spiritual evolution.",
      "This number connects you with your karmic journey. It reflects the lessons you are here to learn and how you can best use your gifts to serve yourself and others.",
      "Your destiny number serves as a constant reminder of your true path. It encourages you to align with your inner truth and walk with purpose, knowing that everything is unfolding as it should."
    ]
  },
  lifepath: { 
    key: "lifePathNumber", 
    title: "Your Life Path Number is",
    texts: [
      "Your life path number describes your journey through this lifetime. It reveals the challenges, opportunities, and key lessons that will shape who you are and who you are destined to become.",
      "This number symbolizes the blueprint of your life. It outlines the spiritual path you must follow and provides insights into the talents and struggles you will encounter along the way.",
      "Your life path number helps you understand your personal strengths and weaknesses. It offers guidance in relationships, career choices, and personal growth by aligning you with your true nature.",
      "This number reflects the essence of your inner being. It reveals how you interact with others, what motivates you, and how you can live a life of deeper purpose and meaning.",
      "Your life path number acts as a mirror of your soul. It shows where you shine naturally, where you must put in effort, and how you can use your experiences to live authentically."
    ]
  },
  chineselucky: { 
    key: "chineseLuckyNumber", 
    title: "Your Chinese Lucky Number is",
    texts: [
      "In Chinese culture, this number is seen as a powerful bringer of wealth and harmony. It symbolizes balance in family life, success in business, and protection against negative influences.",
      "This number is believed to attract prosperity and long-lasting happiness. It carries energies that encourage harmony in relationships, growth in opportunities, and stability in finances.",
      "When this number appears, it signifies that luck is on your side. It is especially auspicious for important decisions, partnerships, or new ventures you are planning to take on.",
      "In traditional Chinese belief, this number is tied to longevity, peace, and abundance. It reflects positive vibrations that ensure your efforts yield rewarding outcomes.",
      "This number holds the promise of good fortune and success. It acts as a blessing from the universe, helping you manifest your desires and achieve a balanced and prosperous life."
    ]
  }
};

// Helper to get random text
const getRandomText = (type) => {
  const texts = numberDetails[type]?.texts || [];
  if (texts.length === 0) return "";
  return texts[Math.floor(Math.random() * texts.length)];
};

const NumberPage = ({ type }) => {
  const { userData } = useFormData();
  const [number, setNumber] = useState(null);
  const [randomText, setRandomText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNumber = async () => {
      try {
        const response = await axios.get(
          "https://core-c343.onrender.com/api/lucky-number?",
          {
            params: {
              firstName: userData.name,
              lastName: userData.lastName || "--",
              birthYear: userData.year,
              birthMonth: userData.month,
              birthDay: userData.day,
            },
          }
        );

        const numerology = response.data.data.numerology;
        const mapped = numberDetails[type] || numberDetails.lucky;
        setNumber({ title: mapped.title, value: numerology[mapped.key] });
        setRandomText(getRandomText(type));
      } catch (err) {
        console.error(err);
        setError("Failed to fetch number data.");
      } finally {
        setLoading(false);
      }
    };

    fetchNumber();
  }, [type, userData]);

  if (loading) return <div className="number-page">Loading...</div>;
  if (error) return <div className="number-page">{error}</div>;

  return (
    <div className="number-page">
      <InnerNav />
      <div className="number-content">
        <div className="number-card">
          <h2>{number.title}</h2>
          <h1>{number.value}</h1>
          <p className="number-description">{randomText}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NumberPage;
